import {API_BASE} from "./jsonApi";

export const getCompanyLogo = (key: string, retina: boolean = false): string =>
  `${API_BASE}/external_api/media_assets/company_logo/${key}${retina ? "/2x" : ""}`;

const mediaAssets = {getCompanyLogo};

export default mediaAssets;
